import { render, staticRenderFns } from "./MsCol.vue?vue&type=template&id=42ad5d9c&lang=html"
import script from "./MsCol.vue?vue&type=script&lang=js"
export * from "./MsCol.vue?vue&type=script&lang=js"
import style0 from "./MsCol.vue?vue&type=style&index=0&id=42ad5d9c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports